import { jsx, jsxs } from 'react/jsx-runtime';
import { Flex, themedColor, useHasMounted } from '@lemonade-hq/cdk';
import { NuisLayer, MEDIA_QUERIES } from '@lemonade-hq/nuis';
import React from 'react';
import styled from 'styled-components';
import { CUSTOMIZE_WIDTH, CUSTOMIZE_MAX_HEIGHT_CCPA, Customize } from './Customize.esm.js';
import { INFO_WIDTH, INFO_MAX_HEIGHT_CCPA, Information, DESCRIPTION_ID, TITLE_ID } from './Information.esm.js';
import { View } from './types.esm.js';
import { useCookieConsent } from './useCookieConsent.esm.js';

function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n        bottom: 20px;\n        left: 20px;\n        width: ",
        "px;\n        max-height: ",
        "px;\n\n        height: revert;\n        padding: revert;\n        bottom: 20px;\n        left: 20px;\n        right: 2px;\n        border-radius: 12px;\n    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: ",
        ";\n  z-index: ",
        ";\n  transition: transform 0.3s ease-in-out, width 0.3s ease-in-out, max-height 0.3s ease-in-out;\n  overflow: hidden;\n  width: unset;\n  max-height: 360px;\n  border-radius: 12px 12px 0 0;\n\n  &.open {\n    transform: translateY(0);\n  }\n\n  &.closed {\n    transform: translateY(calc(100% + 20px));\n  }\n\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n        transform: ",
        ";\n    "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  align-items: flex-end;\n  transform: ",
        ";\n  transition: transform 0.3s ease-in-out;\n\n  ",
        "\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
var CookieConsentWrapper = styled(Flex)(_templateObject1(), themedColor("night"), NuisLayer.TopMostLayer, MEDIA_QUERIES.tabletAndDesktop(_templateObject(), function(param) {
    var view = param.view;
    return view === View.Information ? INFO_WIDTH : CUSTOMIZE_WIDTH;
}, function(param) {
    var view = param.view;
    return view === View.Information ? INFO_MAX_HEIGHT_CCPA : CUSTOMIZE_MAX_HEIGHT_CCPA;
}));
var CardsTracker = styled(Flex)(_templateObject3(), function(param) {
    var view = param.view;
    return view === View.Information ? "translateX(0)" : "translateX(-50%)";
}, MEDIA_QUERIES.tabletAndDesktop(_templateObject2(), function(param) {
    var view = param.view;
    return view === View.Information ? "translateX(0)" : "translateX(-".concat(INFO_WIDTH, "px)");
}));
var CookieConsent = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var _param_baseUrl = _param.baseUrl, baseUrl = _param_baseUrl === void 0 ? "" : _param_baseUrl, onClose = _param.onClose, onAccept = _param.onAccept, onDecline = _param.onDecline, props = _object_without_properties(_param, [
        "baseUrl",
        "onClose",
        "onAccept",
        "onDecline"
    ]);
    var _useCookieConsent = useCookieConsent({
        baseUrl: baseUrl,
        onClose: onClose,
        onAccept: onAccept,
        onDecline: onDecline
    }), isClosed = _useCookieConsent.isClosed, currentView = _useCookieConsent.currentView, navigateToInformationView = _useCookieConsent.navigateToInformationView, navigateToCustomizeView = _useCookieConsent.navigateToCustomizeView, onConfirmHandler = _useCookieConsent.onConfirmHandler, cookieTypesEnabledState = _useCookieConsent.cookieTypesEnabledState, setCookieTypesEnabledState = _useCookieConsent.setCookieTypesEnabledState, onRejectHandler = _useCookieConsent.onRejectHandler, isPersonalInfoView = _useCookieConsent.isPersonalInfoView;
    var hasMounted = useHasMounted();
    if (!hasMounted) return null;
    return /*#__PURE__*/ jsx(CookieConsentWrapper, _object_spread_props(_object_spread({
        "aria-describedby": DESCRIPTION_ID,
        "aria-hidden": isClosed ? true : undefined,
        "aria-labelledby": TITLE_ID,
        "aria-modal": "false",
        className: isClosed ? "closed" : "open",
        ref: ref,
        role: "dialog",
        view: currentView
    }, props), {
        children: /*#__PURE__*/ jsxs(CardsTracker, {
            view: currentView,
            children: [
                /*#__PURE__*/ jsx(Information, {
                    currentView: currentView,
                    isClosed: isClosed,
                    onAccept: onConfirmHandler,
                    onCustomize: navigateToCustomizeView,
                    onReject: onRejectHandler
                }),
                /*#__PURE__*/ jsx(Customize, {
                    cookieTypesEnabledState: cookieTypesEnabledState,
                    currentView: currentView,
                    isClosed: isClosed,
                    isPersonalInfoView: isPersonalInfoView,
                    onAccept: onConfirmHandler,
                    onNavigateBack: navigateToInformationView,
                    setCookieTypesEnabledState: setCookieTypesEnabledState
                })
            ]
        })
    }));
});

export { CookieConsent };
